import * as React from 'react';
import { Pagination as PaginationMUI } from '@mui/material';

import { Container, Item, Row } from 'components/Layout';

export const Pagination = props => {
  const { count, page, onChange } = props;

  return (
    <Container>
      <Row spacing={1}>
        <Item>
          <PaginationMUI
            count={count}
            page={page}
            onChange={onChange}
            showFirstButton
            showLastButton
          />
        </Item>
      </Row>
    </Container>
  );
};

export default Pagination;
